import { ApiStandsRequest, getStands } from '@/shared/api/stand';

export const pavilionsData = async (params?: ApiStandsRequest): Promise<any> => {
    try {
        const finalParams = params || { schemes: [2] };

        const response = await getStands({ params: finalParams });
        return response;
    } catch (error) {
        console.error('Ошибка при загрузке данных:', error);
        throw error;
    }
};
